import React from 'react';

export default function Kills() {
    return (
        <div className="mt-5 grid grid-cols-9 gap-2.5 text-gray-400 text-center">
            <div className="py-5 bg-gradient-to-b from-gray-800 to-gray-900 rounded-3xl">
                <div className="font-bold text-2xl">190</div>
                <div className="mt-5 mb-2.5 flex justify-center">
                    <img src="/static/images/profile/icons/1.png" alt="" />
                </div>
                <div className="font-medium text-xs">Убийства без прицела</div>
            </div>

            <div className="py-5 bg-gradient-to-b from-gray-800 to-gray-900 rounded-3xl">
                <div className="font-bold text-2xl">87</div>
                <div className="mt-5 mb-2.5 flex justify-center">
                    <img src="/static/images/profile/icons/2.png" alt="" />
                </div>
                <div className="font-medium text-xs">Убийства последним патроном</div>
            </div>

            <div className="py-5 bg-gradient-to-b from-gray-800 to-gray-900 rounded-3xl">
                <div className="font-bold text-2xl">190</div>
                <div className="mt-6 mb-7 flex justify-center">
                    <img src="/static/images/profile/icons/3.png" alt="" />
                </div>
                <div className="font-medium text-xs">Ножевые убийство</div>
            </div>

            <div className="py-5 bg-gradient-to-b from-gray-800 to-gray-900 rounded-3xl">
                <div className="font-bold text-2xl">190</div>
                <div className="mt-6 mb-3 flex justify-center">
                    <img src="/static/images/profile/icons/4.png" alt="" />
                </div>
                <div className="font-medium text-xs">Убийства в прыжке</div>
            </div>

            <div className="py-5 bg-gradient-to-b from-gray-800 to-gray-900 rounded-3xl">
                <div className="font-bold text-2xl">190</div>
                <div className="mt-6 mb-3 flex justify-center">
                    <img src="/static/images/profile/icons/5.png" alt="" />
                </div>
                <div className="font-medium text-xs">Убийства с зевса</div>
            </div>

            <div className="py-5 bg-gradient-to-b from-gray-800 to-gray-900 rounded-3xl">
                <div className="font-bold text-2xl">190</div>
                <div className="mt-4 mb-4 flex justify-center">
                    <img src="/static/images/profile/icons/6.png" alt="" />
                </div>
                <div className="font-medium text-xs">Убийства в голову</div>
            </div>

            <div className="py-5 bg-gradient-to-b from-gray-800 to-gray-900 rounded-3xl">
                <div className="font-bold text-2xl">190</div>
                <div className="mt-4 mb-4 flex justify-center">
                    <img src="/static/images/profile/icons/7.png" alt="" />
                </div>
                <div className="font-medium text-xs">Убийства граатами</div>
            </div>

            <div className="py-5 bg-gradient-to-b from-gray-800 to-gray-900 rounded-3xl">
                <div className="font-bold text-2xl">190</div>
                <div className="mt-5 mb-5 flex justify-center">
                    <img src="/static/images/profile/icons/8.png" alt="" />
                </div>
                <div className="font-medium text-xs">Эйсы</div>
            </div>

            <div className="py-5 bg-gradient-to-b from-gray-800 to-gray-900 rounded-3xl">
                <div className="font-bold text-2xl">190</div>
                <div className="mt-5 mb-2.5 flex justify-center">
                    <img src="/static/images/profile/icons/9.png" alt="" />
                </div>
                <div className="font-medium text-xs">Первые убийства</div>
            </div>
        </div>
    );
};